import {
    BodySmallRegular,
    CreditCardIcon,
    Icon,
    PlusIcon,
    Row,
    RowList,
    TrashIcon,
    XStack,
} from 'smoothie';

import {
    formatPaymentMethodLabel,
    type PaymentMethodSummary,
} from '../hooks/usePaymentMethod';
import CardBrandIcon from './CardBrandIcon';

interface PaymentMethodSectionProps {
    paymentMethod: PaymentMethodSummary | null;
    onPressAdd: () => void;
    onPressChange: () => void;
    onPressDelete: () => void;
    /** Hide (not just disable) deleting while a commitment term requires a payment method on file. */
    canDelete?: boolean;
    /** Show which partner added the card — relevant on a joint membership, where either can. */
    showCardOwner?: boolean;
}

const PaymentMethodSection = ({
    paymentMethod,
    onPressAdd,
    onPressChange,
    onPressDelete,
    canDelete = true,
    showCardOwner = false,
}: PaymentMethodSectionProps) => (
    <RowList width="100%" rowHeaderProps={{ title: 'Payment method' }}>
        {paymentMethod?.brand == null ? (
            <Row title="Add card" leftIcon={PlusIcon} onPress={onPressAdd} />
        ) : (
            <>
                <Row
                    title={formatPaymentMethodLabel(paymentMethod)}
                    subtitle={
                        showCardOwner
                            ? (paymentMethod.addedByName ?? undefined)
                            : undefined
                    }
                    leftContentOverride={
                        <CardBrandIcon brand={paymentMethod.brand} />
                    }
                    rightContent={
                        canDelete ? (
                            <XStack
                                alignItems="center"
                                gap={4}
                                onPress={onPressDelete}
                                cursor="pointer"
                            >
                                <BodySmallRegular color="$gray1000">
                                    Delete
                                </BodySmallRegular>
                                <Icon
                                    icon={TrashIcon}
                                    size={16}
                                    color="$gray1000"
                                />
                            </XStack>
                        ) : undefined
                    }
                />
                <Row
                    title="Change payment method"
                    leftIcon={CreditCardIcon}
                    onPress={onPressChange}
                />
            </>
        )}
    </RowList>
);

export default PaymentMethodSection;
